webpackJsonp([75563080901475],{

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(105);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _InputButtonModule = __webpack_require__(206);
	
	var _InputButtonModule2 = _interopRequireDefault(_InputButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_InputButtonModule2.default);
	
	var InputButton = function InputButton(props) {
	  var className = cx({
	    btn: true,
	    orange: props.orange,
	    large: props.large
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: _InputButtonModule2.default.button },
	    _react2.default.createElement(
	      'button',
	      { className: className },
	      props.title
	    )
	  );
	};
	
	exports.default = InputButton;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dark":"#00171F","blue":"#00A8E8","white":"#FFFFFF","green":"#99C24D","btn":"src-components-InputButton----InputButton-module---btn---38B_r","orange":"src-components-InputButton----InputButton-module---orange---1tX-g src-components-InputButton----InputButton-module---btn---38B_r","normal":"src-components-InputButton----InputButton-module---normal---3TkdC src-components-InputButton----InputButton-module---btn---38B_r","large":"src-components-InputButton----InputButton-module---large---3ji-u src-components-InputButton----InputButton-module---btn---38B_r"};

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-pages----RemotePage-module---wrapper---3UAKj"};

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.remoteQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageWrapper = __webpack_require__(56);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _TextContainer = __webpack_require__(104);
	
	var _TextContainer2 = _interopRequireDefault(_TextContainer);
	
	var _InputButton = __webpack_require__(155);
	
	var _InputButton2 = _interopRequireDefault(_InputButton);
	
	var _Inner = __webpack_require__(48);
	
	var _Inner2 = _interopRequireDefault(_Inner);
	
	var _Divider = __webpack_require__(47);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _RemotePageModule = __webpack_require__(638);
	
	var _RemotePageModule2 = _interopRequireDefault(_RemotePageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemotePage = function RemotePage(props) {
	  function createContent() {
	    return { __html: props.data.allFile.edges[0].node.childMarkdownRemark.html };
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: _RemotePageModule2.default.wrapper },
	    _react2.default.createElement(
	      _PageWrapper2.default,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Remote Access - Dominion Systems, LLC', meta: [] }),
	      _react2.default.createElement(
	        _Inner2.default,
	        null,
	        _react2.default.createElement(
	          _TextContainer2.default,
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            props.data.allFile.edges[0].node.childMarkdownRemark.frontmatter.title
	          ),
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: createContent() }),
	          ' '
	        )
	      )
	    )
	  );
	};
	
	exports.default = RemotePage;
	var remoteQuery = exports.remoteQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-remote-js-f5967ddee166a4558082.js